import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  ArrayInput,
  BooleanInput,
  Edit,
  FormDataConsumer,
  minValue,
  SaveButton,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  Toolbar,
  useDataProvider,
  useNotify,
  useRefresh,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { RequiredChain, Tooltip } from '../../components';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { getChainId } from '../../lib';
import { track, EVENTS } from '../../lib/analytics';


const MininumAmountRule = () => {
  const notify = useNotify();
  const navigate = useNavigate();
  const refresh = useRefresh();
  const [fuels, setFuels] = useState([]);
  const dataProvider = useDataProvider();

  useEffect(() => {
    dataProvider.getList('fuels', { sort: { field: 'name', order: 'ASC' }, pagination: { page: 1, perPage: false }, filter: { chainId: getChainId() } })
      .then(({ data }) => {
        setFuels(data);
      })
  }, [getChainId()]);

  const onSuccess = () => {
    track(EVENTS.MINIMUM_AMOUNT_RULE_EDITED, { chain_id: getChainId() ?? 'unknown' });
    notify('ra.notification.updated', { messageArgs: { smart_count: 1 } });
    refresh();
  };

  const onError = (error) => {
    notify('ra.notification.data_provider_error', { type: 'error' });
    navigate('/minimum-amount-rule-edit');
  };

  const transform = (data) => {
    return {
      minimumAmountRule: data.minimumAmountRule.map((item) => {
        const { id, employeeId, ...itemProps } = item;
        return { ...itemProps, chainId: data.id }
      })
    };
  }

  const ToolbarCustom = () => {
    return (
      <Toolbar>
        <SaveButton />
      </Toolbar>
    );
  }

  return (
    <Permission permission={PERMISSIONS.MINIMUM_AMOUNT_RULE}>
      <RequiredChain>
        <Edit id={getChainId()} title="Quantidade Mínima" resource="minimum-amount-rule" mutationMode="pessimistic" mutationOptions={{ onSuccess, onError }} transform={transform}>
          <SimpleForm toolbar={<ToolbarCustom />} >
            <FormDataConsumer>
              {({ formData }) => {
                const disableAddFuel = formData?.minimumAmountRule ? formData.minimumAmountRule.length === fuels.length : false
                return (
                  <ArrayInput label="" source="minimumAmountRule">
                    <SimpleFormIterator disableAdd={disableAddFuel} disableClear disableRemove={(record) => !!(record && record.id)} disableReordering fullWidth>
                      <FormDataConsumer>
                        {({ formData: formMinimumAmountRule, scopedFormData }) => {
                          const selectedFuelIds = formMinimumAmountRule.minimumAmountRule.map(mr => mr.fuelId);
                          const availableChoices = (fuels || []).filter(choice => !selectedFuelIds.includes(choice.id) || scopedFormData.fuelId === choice.id);
                          return (
                            <Grid container spacing={2} alignItems="flex-start" sx={{ width: '100%' }}>
                              <Grid size={{ xs: 12, sm: 'auto' }}>
                                <SelectInput
                                  label="Combustível"
                                  source="fuelId"
                                  choices={availableChoices}
                                  optionText="name"
                                  optionValue="id"
                                  isRequired
                                  inputProps={scopedFormData?.id ? { disabled: true } : { disabled: false }}
                                  sx={{ width: { xs: '100%', sm: 280 } }}
                                />
                              </Grid>
                              <Grid size={{ xs: 12, sm: 'auto' }}>
                                <TextInput
                                  source="amount"
                                  label="Litros (Mínimo)"
                                  format={value => (!value ? '0,00' : `${Number(value).toFixed(2)}`)}
                                  parse={value => (!value ? 0 : +value.replace(/[^\d]/g, '') / 100)}
                                  validate={minValue(1)}
                                  sx={{ width: { xs: '100%', sm: 160 } }}
                                />
                              </Grid>
                              <Grid size={{ xs: 12, sm: 'auto' }}>
                                <Tooltip title="A quantidade de pontos que o cliente vai ganhar, além da pontuação padrão/por grupo. Colocando 2, significa pontos em dobro."
                                  sxContainer={{ alignItems: 'flex-start' }} placement="top-start">
                                  <TextInput
                                    source="factor"
                                    label="Fator"
                                    format={value => (!value ? '0,00' : `${Number(value).toFixed(2)}`)}
                                    parse={value => (!value ? 1 : +value.replace(/[^\d]/g, '') / 100)}
                                    validate={minValue(1)}
                                    sx={{ width: { xs: '100%', sm: 140 } }}
                                  />
                                </Tooltip>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 'auto' }} sx={{ mt: { sm: '22px' } }}>
                                <BooleanInput label="Habilitar" source="isActive" defaultValue={false} />
                              </Grid>
                            </Grid>
                          );
                        }}
                      </FormDataConsumer>
                    </SimpleFormIterator>
                  </ArrayInput>
                );
              }}
            </FormDataConsumer>
          </SimpleForm>
        </Edit>
      </RequiredChain>
    </Permission>
  );
};

export default MininumAmountRule;